import { InjectionToken } from '@angular/core';
import { PushNotificationConfigsLoader } from './types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const PUSH_NOTIFICATIONS_CONFIG_LOADER: InjectionToken<PushNotificationConfigsLoader> =
  new InjectionToken<PushNotificationConfigsLoader>('pushNotificationsConfigs');
